<template>
    <div class="lineAndBar">
        <div class="myChart" :id="lineBarDatas.id" style="width:100%;height:300px"></div>
    </div>
</template>
<script>
    import echarts from 'echarts'
    export default {
        name: 'lineAndBar',
        props: ['lineBarDatas'],
        data() {
            return {}
        },
        mounted() {
            this.drawLine()
        },
        methods: {
            drawLine() {
                var myChart = echarts.init(document.getElementById(this.lineBarDatas.id))
                var option = {
                    color: ['#5B8FF9','#5AD8A6'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer:{
                            type:'shadow'
                        },
                        formatter: function (params, ticket, callback) {
                            let res = params[0].name;
                            for (let i = 0, l = params.length; i < l; i++) {
                                if(params[i].seriesName=='完课率'){
                                    res += '<br/>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value + '%';
                                }else{
                                    res += '<br/>' + params[i].marker + params[i].seriesName + ' : ' + params[i].value;
                                }
                            }
                            return res
                        },
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: true,
                        axisLine: {
                            lineStyle: {
                                color: '#ccc'
                            }
                        },
                        data: this.lineBarDatas.xdata
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    yAxis: [
                        {
                            type: 'value',
                            name: '',
                            min: Math.min.apply(null, this.lineBarDatas.dataBar.list),
                            max: Math.max.apply(null, this.lineBarDatas.dataBar.list),
                            interval: Math.max.apply(null, this.lineBarDatas.dataBar.list)/5,
                            axisLine: {
                                show:false,
                                textStyle: {
                                    color: '#000'
                                }
                            },
                            axisTick: {
                                show: false
                            },
                            splitLine: {
                                lineStyle: {
                                    color: ['#f2f2f2']
                                }
                            }
                        },
                        {
                            type: 'value',
                            name: '',
                            min: Math.min.apply(null, this.lineBarDatas.data.list),
                            max: Math.max.apply(null, this.lineBarDatas.data.list),
                            interval: Math.max.apply(null, this.lineBarDatas.data.list)/5,
                            axisLabel: {
                                // formatter: function (value) {
                                //     // console.log(value)
                                //     // console.log(params)
                                //     // let res = value;
                                //     // if (res.length > 5) {
                                //     //     res = res.substring(0, 4) + "..";
                                //     // }
                                //     return value+'%';
                                // }
                            },
                            axisLine: {
                                show:false, // 不显示众坐标竖线
                                textStyle: {
                                    color: '#000'
                                }
                            },
                            axisTick: { // 去掉众坐标刻度线
                                show: false
                            },
                            splitLine: { // 网格线颜色
                                lineStyle: {
                                    color: ['#f2f2f2']
                                }
                            }
                        }
                    ],
                    series: [{
                        name: this.lineBarDatas.dataBar.title,
                        type: 'bar',
                        barWidth: 30,
                        data: this.lineBarDatas.dataBar.list,
                        yAxisIndex: 0,
                        barWidth : '44',
                        itemStyle : {
                            lineStyle: {
                                color: this.lineBarDatas.dataBar.color // 折线颜色
                            }
                        },
                    },{
                        symbolSize: 2, // 设定实心点的大小
                        smooth: true,
                        symbol: 'circle', // 设定为实心点 none circle
                        name: this.lineBarDatas.data.title,
                        yAxisIndex: 1,
                        type: 'line',
                        data: this.lineBarDatas.data.list,
                        itemStyle: {
                            normal: {
                                lineStyle: {
                                    width: 2, // 折线宽度
                                    color: this.lineBarDatas.data.color // 折线颜色
                                }
                            }
                        }
                    }]
                }
                // 使用刚指定的配置项和数据显示图表。
                myChart.setOption(option)
                window.onresize = function () {
                    myChart.resize()
                }
            }
        },
        watch: {
            lineBarDatas: {
                handler: function() {
                    this.drawLine()
                },
                deep: true
            }
        }
    }
</script>

